// Vendors
import React from 'react';

import { formatCompletionDate, tablefy } from '../../../components/helpers';

const ProjectDetails = ({
  projectData,
  openAccordion,
  handleToggleAccordion,
  newCompletionDate,
  setNewCompletionDate,
  handleUpdateProjectDetails
}) => (
  <div className="grid__col-xs-12 u--margin-bottom-20">
    <button
      className={`btn btn--white btn--block btn--lg btn--pip-accordion btn--has-arrow module-hover-root ${
        openAccordion['basic-info'] === true ? 'btn--pip-accordion--on' : ''
      }`}
      type="button"
      onClick={() => handleToggleAccordion('basic-info')}
    >
      <span className="btn__content u--display-flex u--align-items-center u--justify-content-space-between u--padding-left-20 u--padding-right-20 u--padding-top-5 u--padding-bottom-5 u--height-auto">
        <span className="btn__text">Project Details</span>
        <span className="btn__arrow"></span>
      </span>
    </button>
    <div
      className={
        openAccordion['basic-info'] === true
          ? 'u--display-block u--padding-top-20 u--squash-end u--padding-bottom-10'
          : 'u--display-none'
      }
    >
      {tablefy(
        {
          'Construction Type:': projectData.construction_type,
          'Date Created': new Date(projectData.created).toLocaleDateString(
            'en-us',
            {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit'
            }
          ),
          'Projected Completion Date:': formatCompletionDate(
            projectData.completion_date
          ),
          'Total Incentives:':
            parseInt(projectData.appliance_total_incentives) > 0
              ? ` $${projectData.appliance_total_incentives}`
              : '--'
        },
        false,
        { completion_date: 'Projected Completion Date:' },
        {
          newCompletionDate: newCompletionDate,
          setNewCompletionDate: setNewCompletionDate,
          handleUpdateProjectDetails: handleUpdateProjectDetails
        }
      )}
    </div>
  </div>
);

export default ProjectDetails;
